import { updateFloatingIconsPosition } from "../helpers/utils";
export default (($) => {
    console.log('UNTUCKit : Module : Scroll : loaded');
    const $window = $(window);
    const $html = $('html');
    const $body = $('body');
    const $header = $('header');
    const $footer = $('footer');
    const $toTop = $('.js-top');
    const isAssociate = document.querySelector('body').classList.contains("loggedin-associate");
    let showTop = false;
    let offsetY = 0;
    const scrollActive = () => {
        return $('.no-scroll').length !== 0;
    };
    const bindUIActions = () => {
        $window.on('scroll', () => {
            if ($toTop.length) {
                const belowFold = $window.height();
                const footerOffset = $footer.offset().top;
                const toTopOffset = $toTop.offset().top + $toTop.outerHeight();
                if (showTop) {
                    if (toTopOffset >= footerOffset || toTopOffset <= belowFold) {
                        $toTop.removeClass('is-active');
                        if (!isAssociate) {
                            updateFloatingIconsPosition($toTop.height() * -1);
                        }
                        showTop = false;
                    }
                }
                else {
                    if (toTopOffset < footerOffset && toTopOffset > belowFold) {
                        $toTop.addClass('is-active');
                        if (!isAssociate) {
                            updateFloatingIconsPosition($toTop.height());
                        }
                        showTop = true;
                    }
                }
            }
        });
        $('.js-faq').on('click', function () {
            animate($(this)
                .attr('href')
                .split('#')[1]);
            return false;
        });
        $toTop.on('click', () => {
            animate(0);
            return false;
        });
    };
    function animate(scrollTo) {
        const headerTop = $header.outerHeight();
        const newScrollTop = typeof scrollTo === 'number' ? scrollTo : $(`#${scrollTo}`).offset().top;
        $('html, body').animate({
            scrollTop: newScrollTop - headerTop,
        });
    }
    function lock() {
        offsetY = window.scrollY;
        $body.css('top', `${-offsetY}px`).addClass('no-scroll');
        $html.css('overflow', 'hidden');
    }
    function unlock() {
        if (scrollActive()) {
            $body.css('top', '').removeClass('no-scroll');
            $html.css('overflow', '');
            $window.scrollTop(offsetY);
        }
    }
    const init = () => {
        console.log('UNTUCKit : Module : Scroll : init');
        bindUIActions();
    };
    return {
        animate,
        init,
        lock,
        unlock
    };
})($);
